module.exports = __webpack_public_path__ + "img/yx.4a02292d.png";